<div class="modal" [ngClass]="{ 'is-active': active }">
  <div class="modal-background"></div>
  <div class="modal-content">
    <ng-content></ng-content>
  </div>
  <button (click)="dismissModal()" class="modal-close is-large" data-qa-id="Close Modal Button"></button>
</div>
